import { render, staticRenderFns } from "./category.html?vue&type=template&id=b80713e4&scoped=true&ref=newEquipment&"
import script from "./category.js?vue&type=script&lang=js&"
export * from "./category.js?vue&type=script&lang=js&"
import style0 from "./category.scss?vue&type=style&index=0&id=b80713e4&lang=scss&scoped=true&"
import style1 from "./category.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80713e4",
  null
  
)

export default component.exports